import { Routes } from '@angular/router';
import { ContactsComponent } from './components/contacts/contacts.component';
import { EmailPreferencesComponent } from './components/email-preferences/email-preferences.component';
import { EmailReceivedComponent } from './components/email-received/email-received.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PreferenceUpdateComponent } from './components/preference-update/preference-update.component';
import { EmailPreferencesV2Component } from './components/email-preferences-v2/email-preferences-v2.component';

export const publicRoutes: Routes = [
    { 
      path: 'user-consent/UpdatePreferenceV2', 
      component: EmailPreferencesV2Component 
    },
    { 
      path: 'user-consent/UpdatePreference', 
      component: EmailPreferencesComponent 
    },
    { 
      path: 'user-consent/ContactRequest', 
      component: ContactsComponent 
    },
    { 
      path: 'user-consent/:id/ContactRequest', 
      component: ContactsComponent 
    },
    { 
      path: 'user-consent/UpdatePreference/update-successful', 
      component: PreferenceUpdateComponent
    },
    { 
      path: 'user-consent/MailReceived', 
      component: EmailReceivedComponent 
    },
    { 
      path: 'user-consent/page-not-found', 
      component: PageNotFoundComponent 
    },
    { 
      path: '**', 
      component: PageNotFoundComponent 
    }
];
